import React from 'react';
import { useTranslation } from 'react-i18next';

import { Message } from '@weezevent/nacre';

const AttendeeDeletionAction = () => {
    const { t } = useTranslation();

    return (
        <Message type="warning" title={t('ticket.moderation.statusesTransitions.actions.attendeeDeletion.title')}>
            {t('ticket.moderation.statusesTransitions.actions.attendeeDeletion.message')}
        </Message>
    );
};

export default AttendeeDeletionAction;
